/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import AdService from '../../services/adService';
import * as urlUtils from '../../utils/urlUtils';

class Advert extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { 
            advert: null,
            adsenseOnly: !this.props.textOnly && (this.props.adsenseOnly || Math.random() < 0.25),
            adsenseBlocked: false
        };
    }

    componentDidMount() {        
        this.initialise(this.props, this.state.adsenseOnly, this.state.adsenseBlocked);        
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.adsenseOnly !== nextProps.adsenseOnly || this.props.location.pathname !== nextProps.location.pathname || this.state.adsenseBlocked !== nextState.adsenseBlocked) {
            const adsenseOnly = !nextState.adsenseBlocked && !this.props.textOnly && (nextProps.adsenseOnly || Math.random() < 0.25);
            this.setState({ adsenseOnly }, () => {
                this.initialise(nextProps, adsenseOnly, nextState.adsenseBlocked);
            });
        }
    }

    initialise(props, adsenseOnly, adsenseBlocked) {
        if(!adsenseOnly || adsenseBlocked) {
            AdService.getAdvert(props.adType, props.textOnly)
                .then(advert => {
                    this.setState({ advert }, () => {
                        if(this.props.onLoaded) {
                            this.props.onLoaded();
                        }
                    });
                });
        }        
        else {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
            if(!window.adsbygoogle.loaded) {                
                $.getScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js')
                    .fail((jqxhr, settings, exception ) => {
                        this.setState({ adsenseBlocked: true });
                    });
            }
            else {
                //wait 3 seconds and then call onLoaded
                window.setTimeout(() => {
                    if(this.props.onLoaded) {
                        this.props.onLoaded();
                    }
                }, 3000);
            }
        }
    }

    render() {        
        const adsenseOnly = this.state.adsenseOnly;
        const advert = this.state.advert;
        if(adsenseOnly) {
            const square = this.props.adType === 'Square';
            const style = square ? { display: 'inline-block', width: '300px', height: '250px' } : { display: 'block' };
            const adSlot = square ? '1469191094' : '3370753097';
            const responsive = !square;
            const format = square ? null : 'auto';
            return (
                <ins key={this.props.location.pathname}
                    className="adsbygoogle"
                    style={style}
                    data-ad-client="ca-pub-5843337326619722"
                    data-ad-slot={adSlot}
                    data-ad-format={format}
                    data-full-width-responsive={responsive} />
            );                 
        }
        else if(advert) {
            if(advert.AdType === 'Text') {
                const adText = advert.Text.replace(/\[orange\]/g, '<span style="color:#e55d1e">').replace(/\[\/orange\]/g, '</span>');
                return (
                    <div key={this.props.location.pathname}
                        style={{ textAlign: 'left', padding: this.props.textPadding ? '5px' : null }}>
                        <a href={`/go/${this.state.advert.LocalUrl}`} target="_blank" rel="nofollow" onClick={urlUtils.logExternalLinkClick} dangerouslySetInnerHTML={{__html: adText}} />
                        <img src={advert.ImageTrackingUrl} width="1" height="1" border="0" style={{ width: '1px', height: '1px'}} />
                    </div>
                );
            }
            else if(advert.AdType === 'Image') {
                return (
                    <div key={this.props.location.pathname} 
                        style={{ textAlign: 'center' }}>
                        <a href={`/go/${advert.LocalUrl}`} target="_blank" rel="nofollow" onClick={urlUtils.logExternalLinkClick}>
                            <img src={advert.ImageUrl} width={advert.Width} height={advert.Height} alt={advert.AltText} border="0" />
                        </a>
                    </div>
                );
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
}

Advert.propTypes = {
    adsenseOnly: PropTypes.bool,
    adType: PropTypes.string,
    textOnly: PropTypes.bool,
    location: PropTypes.object.isRequired,
    onLoaded: PropTypes.func,
    textPadding: PropTypes.string
};

export default withRouter(Advert);